import { getNetworkTrackingPropertyGroup } from 'app/dealer/utils';
import { trackAction } from 'app/shared/utils/tracking';
import { DEALERS_INSIGHTS_TIME_DIVISIONS } from 'app/dealer/shared/modules/dealersInsights/api/dealersInsights.api';

// NOTE: using static strings so tracking script can pick up this data for the TRACKING doc
const { MONTH, YEAR } = DEALERS_INSIGHTS_TIME_DIVISIONS;

export const trackTimeDivisionToggle = ({
  network,
  selectedTimeDivisionFilter,
}) => {
  const trackingNetwork = getNetworkTrackingPropertyGroup(network);
  switch (selectedTimeDivisionFilter) {
    case MONTH:
      trackAction(
        'dashboard_listings_month_click',
        {
          category: 'dealer_portal',
          description: 'user clicks on "Monat" to see current status of listings on Dealer Dashboard',
        },
        trackingNetwork,
      );
      break;
    case YEAR:
      trackAction(
        'dashboard_listings_year_click',
        {
          category: 'dealer_portal',
          description: 'user clicks on "Jahr" to see yearly development of listings on Dealer Dashboard',
        },
        trackingNetwork,
      );
      break;
    default:
      break;
  }
};
